import { tableHeaderStyle } from './simple-export'

const educationColumns = [
  { key: 'num', label: 'ลำดับ' },
  { key: 'code', label: 'รหัส' },
  { key: 'level', label: 'Level' },
  { key: 'userName', label: 'ชื่อผู้ใช้งาน' },
  { key: 'title_th', label: 'คำนำหน้า (ไทย)' },
  { key: 'name_th', label: 'ชื่อ (ไทย)' },
  { key: 'surname_th', label: 'นามสกุล (ไทย)' },
  { key: 'nickname_th', label: 'ชื่อเล่น (ไทย)' },
  { key: 'title_en', label: 'คำนำหน้า (Eng)' },
  { key: 'name_en', label: 'ชื่อ (Eng)' },
  { key: 'surname_en', label: 'นามสกุล (Eng)' },
  { key: 'nickname_en', label: 'ชื่อเล่น (Eng)' },
  {
    key: 'division',
    label: 'สายงาน (Group)',
    subLabels: ['ชื่อย่อ', 'สายงาน (ไทย)', 'สายงาน (Eng)']
  },
  { key: 'division_th' },
  { key: 'division_en' },
  {
    key: 'faction',
    label: 'ฝ่าย (Division)',
    subLabels: ['ชื่อย่อ', 'ฝ่าย (ไทย)', 'ฝ่าย (Eng)']
  },
  { key: 'faction_th' },
  { key: 'faction_en' },
  {
    key: 'department',
    label: 'แผนก (Department)',
    subLabels: ['ชื่อย่อ', 'แผนก (ไทย)', 'แผนก (Eng)']
  },
  { key: 'department_th' },
  { key: 'department_en' },
  { key: 'team_th', label: 'ทีม (ไทย)' },
  { key: 'team_en', label: 'ทีม (Eng)' },
  { key: 'position_th', label: 'ตำแหน่ง (ไทย)' },
  { key: 'position_en', label: 'ตำแหน่ง (Eng)' },
  { key: 'report_to', label: 'หัวหน้างาน' },
  { key: 'start_date_th', label: 'วันเริ่มงาน (ไทย)' },
  { key: 'start_date_en', label: 'วันเริ่มงาน (Eng)' },
  { key: 'contract_start_date_th', label: 'วันเริ่มสัญญา (ไทย)' },
  { key: 'contract_start_date_en', label: 'วันเริ่มสัญญา (Eng)' },
  { key: 'duration_text', label: 'อายุงาน (ปี)' },
  { key: 'employed_date_th', label: 'วันที่บรรจุ (ไทย)' },
  { key: 'employed_date_en', label: 'วันที่บรรจุ (Eng)' },
  { key: 'contract_end_date_th', label: 'วันที่สิ้นสุดสัญญา (ไทย)' },
  { key: 'contract_end_date_en', label: 'วันที่สิ้นสุดสัญญา (Eng)' },
  { key: 'end_date_th', label: 'วันพ้นสภาพ (ไทย)' },
  { key: 'end_date_en', label: 'วันพ้นสภาพ (Eng)' },
  { key: 'resign', label: 'สาเหตุการลาออก' },
  { key: 'type', label: 'ประเภทพนักงาน' },
  { key: 'education_degree', label: 'Education Degree' },
  { key: 'institution_name', label: 'Institution Name' },
  { key: 'admission_year', label: 'Education Year Start' },
  { key: 'graduation_year', label: 'Education Year End' },
  { key: 'education_qualification', label: 'Educational Qualification' },
  { key: 'faculty', label: 'Faculty' },
  { key: 'major', label: 'Major' },
  { key: 'grade', label: 'Grade' },
  { key: 'transcript', label: 'Transcript' },
  { key: 'cer_file_name', label: 'Degree Graduated' }
]

const columnCount = educationColumns.length

function createFilterRow(filter) {
  return [
    {
      value: `${filter.title}: ${filter.data ?? 'พนักงาน'}`,
      columnSpan: columnCount
    },
    ...Array(columnCount - 1).fill(null)
  ]
}

function createHeaderRows() {
  const firstRow = []
  const secondRow = Array(columnCount).fill(null)

  educationColumns.forEach((column, index) => {
    if (!column.label) {
      firstRow[index] = null
      return
    }

    if (column.subLabels) {
      firstRow[index] = {
        value: column.label,
        columnSpan: column.subLabels.length,
        ...tableHeaderStyle
      }
      column.subLabels.forEach((subLabel, offset) => {
        secondRow[index + offset] = {
          value: subLabel,
          ...tableHeaderStyle
        }
      })
      return
    }

    firstRow[index] = {
      value: column.label,
      rowSpan: 2,
      ...tableHeaderStyle
    }
  })

  return [firstRow, secondRow]
}

export function buildEducationReportSheet({ filterEx = [], data = [] }) {
  return {
    sheetData: [
      ...filterEx.map(createFilterRow),
      ...createHeaderRows(),
      ...data.map((row) =>
        educationColumns.map((column) => ({
          value: row[column.key] ?? ''
        }))
      )
    ],
    sheetOptions: {
      sheet: 'Sheet1'
    }
  }
}

export const educationReportColumnCount = columnCount
